import { getApiClient } from "../http/client";

async function registerFcmToken(token: string, siteId?: number | null): Promise<void> {
  await getApiClient().post<void>("/push/subscriptions", {
    token,
    siteId: siteId ?? undefined,
    deviceLabel: navigator.userAgent,
  });
}

export const pushService = {
  registerFcmToken,
};
